import React from "react";

import { getImage, ImageType } from "../../helpers/imageHelper";
import { useStrings } from "../../localization/localizationHelpers";

import { PartnerBuildSection } from "./components/PartnerBuildSection";
import { PartnerCommunitySection } from "./components/PartnerCommunitySection";
import { PartnerCtaSection } from "./components/PartnerCtaSection";
import { PartnerFaqSection } from "./components/PartnerFaqSection";
import { PartnerFinalCtaSection } from "./components/PartnerFinalCtaSection";
import { PartnerOperateSection } from "./components/PartnerOperateSection";
import { PartnerProgramsIntro } from "./components/PartnerProgramsIntro";
import { PartnerReachSection } from "./components/PartnerReachSection";
import { PartnerStoriesSection } from "./components/PartnerStoriesSection";
import { PartnerSuccessSection } from "./components/PartnerSuccessSection";
import { LandingCtaPlacements, useLandingCta } from "./useLandingCta";
import * as styles from "./PartnerLandingPage.module.css";

const PartnerLandingPage = () => {
  const handleGetStarted = useLandingCta(LandingCtaPlacements.hero);

  const [heroTitle, heroDescription, getStartedLabel, heroImageAlt] = useStrings(
    "landingHeroTitle",
    "landingHeroDescription",
    "landingHeroGetStartedButton",
    "landingHeroImageAlt"
  );

  return (
    <>
      <div className={styles.pageContainer}>
        <svg className={styles.heroImageFilters} aria-hidden="true">
          <filter id="landing-hero-alpha-threshold">
            <feComponentTransfer>
              <feFuncA type="discrete" tableValues="0 0 1 1" />
            </feComponentTransfer>
          </filter>
        </svg>
        <section className={styles.hero}>
          <img
            className={styles.heroBlur}
            src={getImage("landing_hero_blur", ImageType.Png)}
            alt=""
            aria-hidden="true"
          />
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>{heroTitle}</h1>
            <p className={styles.heroDescription}>{heroDescription}</p>
            <button className={styles.getStartedButton} onClick={handleGetStarted}>
              {getStartedLabel}
            </button>
          </div>
          <div className={styles.heroMedia}>
            <img
              className={styles.heroImage}
              src={getImage("landing_hero", ImageType.Png)}
              alt={heroImageAlt}
              width={640}
              height={650}
            />
          </div>
        </section>
        <PartnerSuccessSection />
        <PartnerProgramsIntro />
        <PartnerReachSection />
        <PartnerBuildSection />
        <PartnerOperateSection />
        <PartnerCtaSection />
        <PartnerStoriesSection />
        <PartnerCommunitySection />
        <PartnerFaqSection />
        <PartnerFinalCtaSection />
      </div>
    </>
  );
};

export default PartnerLandingPage;
